import type { Boundary, TrimSnapshot } from "../types/project";
import { clampFrame } from "./time";

export function normalizeTrim(
  snapshot: TrimSnapshot,
  durationFrames: number,
): TrimSnapshot {
  const startFrame = clampFrame(snapshot.startFrame, durationFrames);
  const endFrame = clampFrame(snapshot.endFrame, durationFrames);
  return startFrame <= endFrame
    ? { startFrame, endFrame }
    : { startFrame: endFrame, endFrame: startFrame };
}

export function setBoundary(
  snapshot: TrimSnapshot,
  boundary: Boundary,
  requestedFrame: number,
  durationFrames: number,
): TrimSnapshot {
  if (boundary === "start") {
    return {
      ...snapshot,
      startFrame: Math.min(
        clampFrame(requestedFrame, durationFrames),
        snapshot.endFrame,
      ),
    };
  }
  return {
    ...snapshot,
    endFrame: Math.max(
      clampFrame(requestedFrame, durationFrames),
      snapshot.startFrame,
    ),
  };
}

export function nudgeBoundary(
  snapshot: TrimSnapshot,
  boundary: Boundary,
  deltaFrames: number,
  durationFrames: number,
): TrimSnapshot {
  return setBoundary(
    snapshot,
    boundary,
    snapshot[boundary === "start" ? "startFrame" : "endFrame"] + deltaFrames,
    durationFrames,
  );
}

export function selectionFrames(snapshot: TrimSnapshot): number {
  return Math.max(0, snapshot.endFrame - snapshot.startFrame);
}
